
import classNames from 'classnames';
import { useFilterContext } from 'components/templates/showcase/content';
import { motion } from 'framer-motion';
import React, { useState, FC, useRef, useEffect, useCallback } from 'react';
import styles from './Filter.module.css';
import he from "he";
import { PlusMinusToggle } from 'components/atoms';

type TAccordianProps = {
    label: string[],
    iconType: string,
    list: { Name: string, CountryName?: string, TagName: string }[],
    lastOfType: boolean;
}

export const FilterOption: FC<TAccordianProps> = ({
    label,
    iconType,
    list,
    lastOfType
}) => {

    const { filterState, handleFilterState } = useFilterContext()

    const [expanded, setExpanded] = useState<boolean>(false);
    const handleExpand = useCallback(() => setExpanded(!expanded), [expanded]);
    const ref = useRef(null);
    const [h, setH] = useState<null | number>(null);
    const [rendered, setRendered] = useState<boolean>(false);

    useEffect(() => {
        setH(ref.current.offsetHeight);
        setRendered(true);
    }, []);

    /**
     * Update filter state, add or remove items from the list.
    */
    const handleSelection = (label: string, item: string) => {
        const propExists = filterState && filterState[label] && filterState[label];
        const itemExists = filterState && filterState[label] && filterState[label].includes(item);
        let data = filterState;

        if (itemExists) {
            let a = data[label];
            a.splice(a.indexOf(item), 1)
            data = {
                ...filterState,
                [label]: a
            }
        } else {
            data = {
                ...filterState,
                [label]: propExists ? [...propExists, item] : [item]
            }
        }

        handleFilterState(data);
    }

    /**
     * We need to make sure that the filters in our URL query strings are in our filters list.
     * If they are not we need to make sure they do not reflect in the UI.
    */
    const trueFilterReflection = (label: string) => {
        let hasXFilters = 0;
        const prop = filterState && filterState[label] && filterState[label];
        if (prop && prop.length) {
            list.forEach((item) => {
                prop.includes(item.Name.toLowerCase()) && hasXFilters++
            });
        }
        return hasXFilters ? ` (${hasXFilters}) ` : false
    }

    /**
     * Check if filter item has been selected by user
    */
    const isFilterSelected = (label: string, item) => {
        if (filterState) {
            if (filterState[label]?.includes(item.Name.toLowerCase())) {
                return 'active'
            }
        }

        return 'inactive'
    };

    return (
        <section className="d-flex">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: .5 }}
                key={'filter-list-' + label[1]}
            >
                <div className={styles.wrapper}>
                    <PlusMinusToggle
                        key={`filter-option-${label}}`}
                        handleExpand={() => handleExpand()}
                    >
                        <p className={
                            classNames({ active: trueFilterReflection(label[0]) })}
                        >
                            {label[1]}{trueFilterReflection(label[0])}</p>
                    </PlusMinusToggle>


                </div>

                <motion.div
                    ref={ref}
                    animate={{
                        display: 'block',
                        pointerEvents: expanded ? 'all' : 'none',
                        marginBottom: expanded ? '25px' : '0px',
                        position: 'relative',
                        opacity: expanded ? 1 : 0,
                        height: expanded ? h : '0px',
                        transition: {
                            duration: 0.5,
                        }
                    }}
                    key={label[1]}
                    className={classNames(styles.list, { "pb-40": lastOfType })}
                >
                    {list.map(i =>
                        <button
                            onClick={() => handleSelection(label[0], i.Name.toLowerCase())}
                            className={`bTag ${isFilterSelected(label[0], i)}`}
                            key={i.Name}>
                            {he.decode(i.TagName)}
                        </button>
                    )}
                </motion.div>

            </motion.div>
        </section >
    )
}